import React from 'react';
import PropTypes from 'prop-types';
import ClientItem from './HomeGalleryItem';

const HomeGallery = ({ items }) => (
  <div className="home-gallery-items">
    {items.map((item, index) => (
      <ClientItem item={item} />
    ))}
  </div>
);

HomeGallery.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    image: PropTypes.string,
    url: PropTypes.string,
  })).isRequired,
};

export default HomeGallery;
